import { render, staticRenderFns } from "./UserSocialSelfies.vue?vue&type=template&id=05cdbd8a&"
import script from "./UserSocialSelfies.vue?vue&type=script&lang=js&"
export * from "./UserSocialSelfies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cdbd8a')) {
      api.createRecord('05cdbd8a', component.options)
    } else {
      api.reload('05cdbd8a', component.options)
    }
    module.hot.accept("./UserSocialSelfies.vue?vue&type=template&id=05cdbd8a&", function () {
      api.rerender('05cdbd8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/UserSocialSelfies.vue"
export default component.exports